import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

export default class FixButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value,
      hovering: false,
    };
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
    if (this.props.onChange) this.props.onChange(event.target.value);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  render() {
    // Determine colors based on custom style or defaults
    const isCustom = this.props.style && this.props.style.backgroundColor;
    let backgroundColor, hoverColor;

    if (isCustom) {
      backgroundColor = this.props.style.backgroundColor;
      // Create darker hover color for custom background
      if (backgroundColor === "#dc3545") {
        // Red button
        hoverColor = this.state.hovering ? "#c82333" : backgroundColor;
      } else {
        hoverColor = this.state.hovering ? backgroundColor : backgroundColor;
      }
    } else {
      // Default colors
      backgroundColor = this.state.hovering ? "#530004" : "#A00008";
      hoverColor = backgroundColor;
    }

    // Default style
    const defaultStyle = {
      transition: "all .3s",
      marginBottom: "10px",
      marginLeft: "5px",
      padding: "10px",
      backgroundColor: hoverColor,
      cursor: "pointer",
      borderRadius: "5px",
      border: "0px",
      color: "#ffffff",
      boxShadow: this.state.hovering
        ? "0px 2px 5px darkgrey"
        : "0px 2px 5px lightgrey",
    };

    // Merge with custom style if provided
    const finalStyle = this.props.style
      ? { ...defaultStyle, ...this.props.style, backgroundColor: hoverColor }
      : defaultStyle;

    return (
      <button
        onClick={async () => {
          if (!this.props.isLoading) {
            this.props.callback();
          }
        }}
        style={finalStyle}
        onMouseEnter={() => this.setState({ hovering: true })}
        onMouseLeave={() => this.setState({ hovering: false })}
        disabled={this.props.isLoading}
      >
        {this.props.isLoading ? (
          <CircularProgress size={20} style={{ color: "#ffffff" }} />
        ) : (
          this.props.title
        )}
      </button>
    );
  }
}

const mainClass = {
  padding: "10px",
};

const name = {};

const inputText = {
  width: "300px",
  padding: "10px",
};
